<mat-form-field class="form-field" [appearance]="appearance">
    
    <mat-label>
        {{label}}
    </mat-label>

    <ng-container *ngIf="multiple; else defaultNotificationSingleSelection">

        <mat-select [formControl]="formControl" multiple>
            <mat-option *ngFor="let defaultNotification of defaultNotifications" [value]="defaultNotification.guid">
                {{defaultNotification.internalDescription}}
            </mat-option>
        </mat-select>

    </ng-container>

    <ng-template #defaultNotificationSingleSelection>

        <mat-select [formControl]="formControl">
            <mat-option *ngFor="let defaultNotification of defaultNotifications" [value]="defaultNotification.guid">
                {{defaultNotification.internalDescription}}
            </mat-option>
        </mat-select>

    </ng-template>
    
</mat-form-field>
